import React, {Component} from 'react';

import HelpLinks from '../help-links.js';

export default class OptionalText extends Component {

  constructor(props) {
    super(props);
    this.handleNameChange = this.handleNameChange.bind(this);
    this.handleLabelChange = this.handleLabelChange.bind(this);
    this.handlePriceChange = this.handlePriceChange.bind(this);
    this.handleDeleteCustomisation = this.handleDeleteCustomisation.bind(this);
    this.helpLinks = new HelpLinks('text-optional');
  }

  handleNameChange(e) {
    this.props.changeName(this.props.customisation.index, e.target.value);
  }

  handleLabelChange(e) {
    this.props.changeLabel(this.props.customisation.index, e.target.value);
  }

  handlePriceChange(e) {
    this.props.changePrice(this.props.customisation.index, e.target.value);
  }

  handleDeleteCustomisation() {
    this.props.deleteCustomisation(this.props.customisation.index);
  }

  render() {
    return (
      <section className="OptionalText customisation">
        <h3 className="OptionalText__type">VARIATION TYPE: Text (optional)</h3>
        <div>
          <span>
            <label>Label:</label>
            <input
              className="OptionalText__name"
              value={this.props.customisation.name}
              onChange={this.handleNameChange}
              placeholder="Eg. 'Would you like a gift message?'"
            />
          </span>
          <p className="hint">
            This text appears above the box the customer types into.
            &nbsp;
            {this.helpLinks.linkFor('label')}
          </p>
        </div>
        <div>
          <span>
            <label>Customer hint:</label>
            <input
              className="OptionalText__label"
              value={this.props.customisation.label}
              onChange={this.handleLabelChange}
              placeholder="Eg. 'Write your message here if applicable'"
            />
          </span>
          <p className="hint">
            This text appears as a hint in the box before the customer types anything.
            &nbsp;
            {this.helpLinks.linkFor('customer-hint')}
          </p>
        </div>
        <div>
          <span>
            <label>Variation cost (optional):</label>
            <input
              className="OptionalText__price"
              value={this.props.customisation.price}
              onChange={this.handlePriceChange}
              placeholder="Eg. '1.99'"
            />
          </span>
          <p className="hint">
            If this variation has an additional cost, add it here.
            &nbsp;
            {this.helpLinks.linkFor('variation-cost')}
          </p>
        </div>
        <div className="ui-options">
          <button
            className="OptionalText__delete del"
            onClick={(e) => {
              if (window.confirm('Are you sure you want to delete this variation?')) {
                this.handleDeleteCustomisation(e);
              }
            }}
          >&times; Delete</button>
        </div>
      </section>
    );
  }

}



// WEBPACK FOOTER //
// ./src/app/item-customisations/fields/optional-text.js